<mat-form-field appearance="outline">
  <mat-label>{{labelField}}</mat-label>
  <mat-select (selectionChange)="onChangeSelect($event)" [multiple]="multiple" [value]="selected" (click)="click()">
    <input class="inputSearchSelect" type="text" [(ngModel)]="searchText"
      (keyup)="onKey($event.target.value)" placeholder="Pesquisar" autocomplete="off" (keydown)="$event.stopPropagation()">
      @for (item of selectedList; track item; let i = $index) {
        <mat-option [disabled]="preSelectedBlock && preSelectedlist[i] && item[idField] == preSelectedlist[i][idField]" [value]="item[idField]">
          {{item[nameField]}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>